import SupportedLobModules from 'integration/policyTransaction/SupportedLobModules';
import 'edge/policyjob/app';
import 'edge/policycommon/app';
import 'edge/platform/navigation/module';

const dependencies = SupportedLobModules;

dependencies.push('edge.policyjob.app');
dependencies.push('edge.policycommon.app');
dependencies.push('edge.platform.navigation');

export default angular.module('edge.transaction.app', dependencies);
